/**
 *
 * PageHeading
 *
 */

import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';

function setHeaderWidth(urlName) {
  if (urlName === 'scottsdale') {
    return {
      width: '40rem',
      marginLeft: 'auto',
      marginRight: 'auto',
    };
  }
  return {
    width: '60rem',
    marginLeft: 'auto',
    marginRight: 'auto',
  };
}

function resolveAccessibleTitle(children, mobileTitle) {
  if (typeof children === 'string' && children.trim()) {
    return children.trim();
  }
  if (typeof mobileTitle === 'string' && mobileTitle.trim()) {
    return mobileTitle.trim();
  }
  return '';
}

function PageHeading(props) {
  const addClass = props.primary ? 'meet-squeeze__hdg' : '';
  const { pathname } = props;
  let applyHeaderStyles = false;
  if (pathname) {
    if (pathname.includes('more-info')) {
      applyHeaderStyles = true;
    }
  }

  const accessibleTitle = resolveAccessibleTitle(
    props.children,
    props.mobileTitle,
  );
  const mobileTitle =
    props.mobileTitle != null ? props.mobileTitle : props.children;
  const headingRef = useRef(null);
  const { focusOnMount = true, headingId } = props;

  // SPA route changes do not move VoiceOver focus; land on the page title so
  // context is announced before the first control.
  useEffect(
    () => {
      if (!focusOnMount || !accessibleTitle || !headingRef.current) {
        return;
      }
      headingRef.current.focus();
    },
    [accessibleTitle, focusOnMount],
  );

  const visualHeadingClass = `header-font own-header ucase ${props.addClass ||
    addClass}`;

  return (
    <div>
      {!props.noDisplay && (
        <header
          className="header-hdr"
          style={applyHeaderStyles ? setHeaderWidth(props.urlName) : {}}
        >
          <h1
            id={headingId}
            ref={headingRef}
            tabIndex={focusOnMount ? -1 : undefined}
            className="u-sr-only"
          >
            {accessibleTitle}
          </h1>
          {/* Outline font uses ::before/::after from title; keep decorative only. */}
          <p
            className={`${visualHeadingClass} hide-phone`}
            title={accessibleTitle}
            aria-hidden="true"
          >
            {props.children}
          </p>

          <p
            className={`${visualHeadingClass} phone-only`}
            title={
              typeof mobileTitle === 'string' ? mobileTitle : accessibleTitle
            }
            aria-hidden="true"
          >
            {mobileTitle}
          </p>
          {props.additionalMobileContent}
          <div className="curve curve--blue-inner phone-only">
            <svg
              className="phone-only"
              width="100%"
              height="23px"
              viewBox="0 0 375 23"
              preserveAspectRatio="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 0c36.1 13.7 106.528 23 187.5 23S338.9 13.7 375 0H0z"
                fill="#8DD1D8"
                fillRule="evenodd"
              />
            </svg>
          </div>
        </header>
      )}
      {props.noDisplay && (
        <header
          className={props.noDisplay ? 'header-hdr hide-phone' : 'header-hdr'}
        >
          <h1
            ref={headingRef}
            tabIndex={-1}
            className={`${visualHeadingClass} hide-phone`}
            title={accessibleTitle}
            aria-label={accessibleTitle}
          >
            {props.children}
          </h1>
        </header>
      )}
    </div>
  );
}

PageHeading.propTypes = {
  pathname: PropTypes.string,
  children: PropTypes.node.isRequired,
  addClass: PropTypes.string,
  primary: PropTypes.bool,
  additionalMobileContent: PropTypes.bool,
  mobileTitle: PropTypes.string,
  noDisplay: PropTypes.string,
  urlName: PropTypes.string,
  focusOnMount: PropTypes.bool,
  headingId: PropTypes.string,
};

export default PageHeading;
